import React from "react";
import {  productBg } from "../../../assets/images";
import { useTranslation } from "react-i18next";

const About = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  return (
    <div>
      <div className="md:max-w-container max-w-containerSm w-full mx-auto pt-10 md:pt-20">
  <div
    className="relative py-6 px-3 flex flex-col justify-center items-center text-center rounded-[12px]"
    style={{
      backgroundImage: `url(${productBg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: window.innerWidth < 640 ? "288px" : "344px",
    }}
  >
    {/* Overlay */}
    <div className="absolute inset-0 bg-black opacity-10 rounded-[12px]"></div>

    {/* Content */}
    <div className="relative z-10 w-full flex flex-col items-center">
      <p className="text-center text-[24px] md:text-[28px] font-semibold text-white">
        {t("Təbiiliyi və keyfiyyəti birləşdirən yerli brend!")}
      </p>
      <p className="text-center text-white text-[14px] md:text-[16px] mt-3">
        {t("Biz hər qadının gözəlliyini vurğulamaq üçün buradayıq")}
      </p>
      <div className="w-full">
        <a className="w-full md:w-auto" href={`/${currentLanguage}/about`}>
          <button className="h-[44px] w-full md:w-[125px] mt-[24px] md:mt-[32px] bg-[#181D27] text-white rounded-[4px]">
            {t("Haqqımızda")}
          </button>
        </a>
      </div>
    </div>
  </div>
</div>

    </div>
  );
};

export default About;
